import React, { MouseEvent, ReactNode, useCallback, useMemo } from "react";
import { NoExtraProperties } from "../components/utils";

export interface ColumnProps<T> {
    id: string
    label: string | JSX.Element
    colGroup?: string
    thGroup?: string
    render?(item: T, index?: number): ReactNode
}

export type Column<T> = NoExtraProperties<ColumnProps<T>>

function ColumnHeader<T>({column}:{column:Column<T>}){
    return <th className={column.thGroup}>{column.label}</th>
}   

function TableCol<T>({col, item, index}:{col:Column<T>, item:T, index:number}){
    const render = useCallback(col.render, [col]);
    return <td className={col.colGroup}>
        {render(item, index)}
    </td>
}

function TableRow<T>({columns, item, index, onClick}:{columns:Column<T>[], item:T, index:number, onClick:(i:T, e:MouseEvent) => void}){

    return <tr onClick={onClick ? (e) => onClick(item, e) : null}>
        {columns.map((c, i) => <TableCol key={c.id} index={index} col={c} item={item} />)}
    </tr>
}


export function Table<T>({data, columns, onClick}:{data:T[], columns:Column<T>[], onClick?:(i:T, e:MouseEvent) => void}){
    return <table className="table table-striped table-hover">
                <thead>
                <tr>
                   {columns.map((c, i) => <ColumnHeader key={i} column={c} />)}
                </tr>
                </thead>
                <tbody>
                {
                    data.map( (r, i) => <TableRow key={i} item={r} index={i} columns={columns} onClick={onClick} />) 
                }
                </tbody>
            </table>
        
}

export function ClickShield({children}:{children:ReactNode}){
    return <div onClick={(e) => e.stopPropagation()}>
        {children}
    </div>
}